// Markdown joins single line breaks; keep them visible, except before list items.
export const withLineBreaks = (text) =>
  (text ?? '').replace(/([^\n])\n(?!\n|[ \t]*(?:[-*+]|\d+[.)])[ \t])/g, '$1  \n')
